import type { JsonOrder } from "./types";

const hasFreeProduct = (o: JsonOrder): boolean =>
  Array.isArray(o.products) &&
  o.products.some((p) => ((p as { unitPrice?: number }).unitPrice ?? 0) === 0);

// Mirrors the tablet's cart.orderCount semantics (src/components/Cart.js:486-490):
// a tour counts only if the order contains at least one free product AND is not
// the initial seeded order.
export const countBuffetTours = (orders: JsonOrder[]): number =>
  orders.filter((o) => !o.initialOrder && hasFreeProduct(o)).length;
